// PARAMETERS
global.APP_CODE = 6
global.EMP_CODE = 1
global.MODULO_ACCESO = 2
global.MODULO_CODE = 395

//submenu name
global.CONFIG_DASH = 'Dashboard'
global.CONFIG_TEMAS = 'Areas'
global.SECURE_USERS = 'Usuarios'
global.SECURE_ROLES = 'roles'

//menu icons
global.CONFIG_DASH = 'Dashboard'
global.CONFIG_TEMAS = 'Areas'
global.CONFIG_EMPRESAS = 'Empresas-grupos'
global.SECURE_USERS = 'Usuarios'
global.SECURE_ROLES = 'roles'

global.SECURE_USERSBI = 'Usuarios-BI'
global.SECURE_ROLESNI = 'roles-BI'

// error var
global.VARIANT_SUCCESS = 'success'
global.VARIANT_ERROR = 'error'
global.VARIANT_WARNING = 'warning'
global.DELAY = 2000
global.DELAY_DASH = 5000

global.SUCCESS_CODE = 200

// messages
global.ERROR_MESSAGE = 'Ocurrió un error intente en unos momentos'
global.SUCCESS_MESSAGE_GET = 'Consulta de datos exitosa'
global.SUCCESS_MESSAGE_POST = 'Información actualizada'
global.LOGIN_MESSAGE = 'Bienvenido '
global.APP_HEADER = 'UEhBTlRPTVhfREJJ'
//global.APP_HEADER = 'UEhBTlRPTVhfTE1T'
global.APP_HEADERCONF = 'UEhBTlRPTVhfTE1T'
global.APP_IDORG = '365509c8-9596-4506-a5b3-487782d5876e'